<template>
  <div style="width: 100%;height: 100%;overflow: auto;" v-loading="isLoading">
    <div class="history-wrap">

      <!---------- history head ---------->
      <div class="history-head">
        <div class="title"><span>修改动态</span></div>
        <el-button size="mini" @click="close" round class="shut-button">返回</el-button>
      </div>
      <!---------- history head end ---------->

      <!---------- history body ---------->
      <div class="history-body clearfix">
        <!---------- show ---------->
        <div class="history-show" style="width: 30%;">
          <el-scrollbar ref="myScrollbar" class="whaty-scroll mTable-body myTableBody" wrap-class="whaty-scroll-wrap"
                        :style="{height: bodyHeight + 'px'}">
            <div class="history-info">
              当前数据
            </div>
            <div class="history-inner">
              <div class="list">
                <div class="list-row" v-for="(value, key) in currentData">
                  <span class="list-head" :title="key">{{ key }}</span>
                  <div class="list-body">
                    <el-tooltip class="item" :open-delay="700" effect="dark" :content="nonNullValue(value)"
                                placement="top">
                      <span class="dispensible">{{ nonNullValue(value) }}</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <!---------- show end ---------->

        <!---------- record ---------->
        <div class="history-record" style="width: 69%;">
          <div class="history-info">
            说明：<span class="lab lab-red-light">红色</span>表示修改前，<span class="lab lab-green-light">绿色</span>表示修改后，<span
            class="lab">&lt;空&gt;</span>表示无数据
          </div>
          <el-scrollbar ref="myScrollbar" class="whaty-scroll mTable-body myTableBody" wrap-class="whaty-scroll-wrap"
                        :style="{height: bodyHeight - 36 + 'px'}">
            <div class="history-inner" style="background-color: white;">
              <div class="record-row" v-for="data in statusData">
                <div class="record-row-wrap">
                  <div class="record-row-head clearfix">
                    <span class="pull-left name"><i class="mng icon-login-user-fill"></i>
                      <span class="text">{{ data.operateUser }}</span>&nbsp;&nbsp;&nbsp;
                      <span style="font-weight: 500;">{{ data.operateTime }}</span>
                    </span>
                    <span class="pull-right time">{{ data.operateName }}</span>
                  </div>
                  <div class="record-row-body">
                    <div class="list">
                      <div class="list-row" v-for="diff in data.diffs">
                        <span class="list-head">{{ diff.label }}:</span>
                        <div class="list-body">
                          <el-tooltip class="item" :open-delay="700" effect="dark" :content="nonNullValue(diff.before)"
                                      placement="top">
                            <span class="lab lab-red-light dispensible modify-target">{{ nonNullValue(diff.before) }}</span>
                          </el-tooltip>
                          <span class="modify-text">修改为</span>
                          <el-tooltip class="item" :open-delay="700" effect="dark" :content="nonNullValue(diff.after)"
                                      placement="top">
                            <span class="lab lab-green-light dispensible modify-target">{{ nonNullValue(diff.after) }}</span>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <!---------- record end ---------->
      </div>
      <!---------- history body end ---------->
    </div>
  </div>
</template>

<script>
  import util from '@/libs/util'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  export default {
    props: {
      id: {
        type: String
      },
      currentData: {
        type: Object
      },
      namespace: {
        type: String
      }
    },
    name: 'data-history-draw',
    data() {
      return {
        isLoading: false,
        statusData: null,
        emptyData: [],
        pageHeight: 200
      }
    },
    mounted() {
      this.isLoading = true
      util.ajax.get('/entity/record/dataHistorySearch/changeDataHistory?namespace=' + this.namespace + '&id=' + this.id).then(res => {
        if (res.data.meta && res.data.meta.errCode === 0) {
          this.statusData = res.data.data
        } else {
          this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
        }
        this.isLoading = false
      }).catch(err => {
        console.error(err)
        this.$notify.error({title: '提示', message: '系统错误'})
        this.isLoading = false
      })
      this.$nextTick(this.update)
      addResizeListener(this.$el, this.update)
    },
    beforeDestroy() {
      removeResizeListener(this.$el, this.update)
    },
    computed: {
      bodyHeight: function () {
        return this.pageHeight - 61
      }
    },
    methods: {
      update: function () {
        this.pageHeight = this.$el.offsetHeight
      },
      close: function () {
        this.$emit('close')
      },
      nonNullValue: function (value) {
        return value && value !== null && value !== '' ? value : '<空>'
      }
    }
  }
</script>

<style scoped>
  .el-scrollbar {
    overflow-x: hidden;
  }

  .shut-button {
    position: absolute;
    right: 20px;
    top: 23%;
  }

  .history-wrap {
    background-color: white;
    border: 1px solid #ddd;
    -webkit-box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  }

  .history {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: inherit;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .history-head {
    position: relative;
    padding: 15px 20px;
    border-bottom: 1px solid #ddd;
  }

  .history-head .title {
    font-size: 16px;
    color: #222;
    vertical-align: middle;
    height: auto !important;
    min-height: auto !important;
  }

  .history-head .title i {
    margin-right: 8px;
    font-size: 20px;
    color: #475ec2;
    vertical-align: middle;
  }

  .history-head .title span {
    font-weight: 600;
  }

  .history-head .shut {
    position: absolute;
    top: 50%;
    right: 20px;
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-top: -12px;
    font-size: 14px;
    color: #666;
    line-height: 24px;
    text-align: center;
  }

  .history-head .shut:hover {
    color: #444;
    background-color: #f5f5f5;
  }

  .history-body > div {
    float: left;
    height: inherit;
  }

  .history-show {
    width: 30%;
    border-right: 1px solid #ddd;
  }

  .history-show .history-inner {
    padding: 20px;
  }

  .history-info {
    padding: 8px 20px;
    font-size: 12px;
    color: #888;
    background-color: #f9f9f9;
    height: 18px;
  }

  .record-row {
    border-bottom: 1px solid #eee;
  }

  .record-row:last-child {
    border-bottom: 0;
  }

  .record-row-wrap {
    padding: 10px 20px;
  }

  .record-row-head {
    margin-bottom: 5px;
  }

  .record-row-head .name {
    color: #222;
  }

  .record-row-head .name i {
    margin-right: 8px;
  }

  .record-row-head .name span {
    font-weight: 600;
  }

  .record-row-head .time {
    font-size: 12px;
    color: #999;
  }

  .record-row .list {
    margin: 0 22px;
  }

  .record-row .list-row {
    border-bottom: 0;
  }

  .record-row .list-head {
    width: 80px;
    padding-left: 0;
    color: #475ec2;
  }

  .record-row .list-body {
    margin-left: 85px;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  .record-row .list-body span {
    margin: 4px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .record-row .list-body span.lab {
    white-space: normal;
  }

  .list-row {
    position: relative;
    border-bottom: 1px solid #eee;
  }

  .list-head {
    position: absolute;
    top: 0;
    left: 0;
    width: 90px;
    padding-left: 10px;
    font-size: 12px;
    color: #999;
    line-height: 36px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .list-body {
    margin-right: 10px;
    margin-left: 100px;
    padding: 7px 0;
    font-size: 12px;
    color: #444;
    line-height: 22px;
    min-height: 22px;
  }



  .lab {
    display: inline-block;
    margin: 0 6px;
    padding: 4px 6px;
    font-size: inherit;
    color: inherit;
    line-height: 1;
    border-radius: 3px;
  }

  .lab-red-light {
    background-color: rgba(251, 74, 74, 0.18);
  }

  .lab-green-light {
    background-color: rgba(56, 193, 127, 0.2);
  }

  .lab-transparent {
    background-color: transparent;
  }

  .dispensible {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap!important;
    width: 100%;
  }

  .modify-target {
    max-width: 45%!important;
    width: auto;
  }

  .modify-text {
    display: inline-block;
    max-width: 10%;
    overflow: hidden;
    bottom: 4px;
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/components/record/data-history-draw.vue